import React from 'react';
import type { FilterableEntityTableProps } from 'c-pagination';
import { Box } from '@mui/material';
import { FlashMessage } from 'c-components';
import TableLoadingRegion from './TableLoadingRegion';

const ContainedRenderer: FilterableEntityTableProps['CustomRenderer'] = ({
    wrapperComponentRef,
    table,
    filterForm,
    loading,
    pagination,
    error,
}) => (
    <Box
        ref={wrapperComponentRef}
        flex={1}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        position="relative"
    >
        {filterForm != null && <Box id="filters">{filterForm}</Box>}

        {error && (
            <Box my={1}>
                <FlashMessage status="error">{error}</FlashMessage>
            </Box>
        )}
        <TableLoadingRegion
            loading={loading}
            flex={1}
            id="table"
            overflow="hidden"
            height="100%"
            display="flex"
        >
            {table}
        </TableLoadingRegion>
        <Box id="pagination">{pagination}</Box>
    </Box>
);

export default ContainedRenderer;
